import React, {useCallback, useMemo} from "react";
import IconButton from "../../../base/button/icon_button";
import {ArrowBack} from "@mui/icons-material";
import {Row} from "reactstrap";
import {DialogActions, DialogContent, DialogTitle, Divider} from "@mui/material";
import Button from "../../../base/button/button";
import SummaryInfoCard from "../../../app-specific/summary-cards/summary-info-card";
import CustomerAutocomplete from "../../../text-fields/autocomplete/customer-autocomplete";
import CustomerAccountingAndSearchesDetails from "../../../app-specific/customer-accounting-and-searches-details";
import {QuickOrderSteps} from "../index";

const QuickOrderCustomerSelectionSection = ({items, changeDialogStatus, close, customer, setCustomer}) => {
    const partsLength = useMemo(() => items?.length ?? 0, [items?.length])
    const quantities = useMemo(() => items.map(e => e.qty).reduce((a, b) => a + b, 0), [items])

    const summaryCard = useMemo(() => ({
        header: {
            title: 'Products Summary',
            value: "",
            loadingValue: "Loading...",
        },
        body: [
            {
                id: 'partsLength',
                title: 'Total Products',
                value: partsLength,
            },
            {
                id: 'quantities',
                title: 'Total Items',
                value: quantities,
            }
        ],
    }), [partsLength, quantities])

    /**
     * Callback function to set the customer
     * @type {(function(*, *): void)}
     */
    const onCustomerChanged = useCallback((e, customer) => {
        setCustomer(customer)
    }, [setCustomer])

    return (
        <>
            <DialogTitle id={'scroll-dialog-title'}>
                <p className={`text-lg text-color-1 my-3 font-weight-bold text-center`}>
                    Quick Order (Customer Selection)
                </p>
                <Divider className='divider'/>
            </DialogTitle>
            <DialogContent>
                <div className={'quick-order-dialog-customer-selection'}>
                    <div className={'d-flex align-items-center mb-3'}>
                        <IconButton
                            className={'mr-2'}
                            color={'secondary'}
                            onPressed={() => changeDialogStatus(QuickOrderSteps.ImportSection)}
                        >
                            <ArrowBack className={'icon normal'}/>
                        </IconButton>
                        <p className={'text-md text-color-2 font-weight-semi-bold'}>
                            Back to part selection
                        </p>
                    </div>
                    <SummaryInfoCard
                        header={summaryCard.header}
                        body={summaryCard.body}
                    />
                    <div className={'mt-3 mb-4'}>
                        <CustomerAutocomplete
                            fullWidth
                            label={'Customer'}
                            value={customer}
                            onChange={onCustomerChanged}
                        />
                        {
                            !!customer &&
                            <CustomerAccountingAndSearchesDetails customer={customer} showAccounting/>
                        }
                    </div>
                </div>
            </DialogContent>
            {
                !!customer &&
                <DialogActions className={'p-0'}>
                    <Row className={'w-100 no-gutters'}>
                        <Divider className='divider'/>
                        <Row className='no-gutters justify-content-between align-items-center w-100'>
                            <Button
                                variant={'dialog'}
                                color={'primary'}
                                onClick={close}
                                borderRadius={'0 8px 0 8px'}
                            >
                                Close
                            </Button>
                            <Button
                                variant={'dialog'}
                                color={'primary'}
                                onClick={() => changeDialogStatus(QuickOrderSteps.SummarySection)}
                                borderRadius={'8px 0 8px 0'}
                            >
                                Submit the order
                            </Button>
                        </Row>
                    </Row>
                </DialogActions>
            }
        </>
    );
}

export default QuickOrderCustomerSelectionSection;
